<template>
  <v-dialog
      v-model="showDialogMemberChange"
      transition="dialog-top-transition"
      width="600">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ member.vorname + ' ' + member.name }} ändern
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialogMemberChange">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="form_update_member" v-on:submit.prevent>
          <v-container>
            <v-row>
              <!--                <v-col cols="3">-->
              <!--                  <v-subheader class="mySubheader">E-Mail</v-subheader>-->
              <!--                </v-col>-->
              <!--                <v-col cols="8">-->
              <!--                  <v-text-field-->
              <!--                      v-model="EditMember.Email"-->
              <!--                      :rules="[rules.required, rules.email]"-->
              <!--                      :error-messages="errorMessages"-->
              <!--                  ></v-text-field>-->
              <!--                </v-col>-->
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-subheader class="mySubheader">Vorname</v-subheader>
              </v-col>
              <v-col cols="8">
                <v-text-field
                    v-model="member.vorname"
                    :rules="[rules.required]"
                    :error-messages="errorMessages"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-subheader class="mySubheader">Nachname</v-subheader>
              </v-col>
              <v-col cols="8">
                <v-text-field
                    v-model="member.name"
                    :rules="[rules.required]"
                    :error-messages="errorMessages"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-subheader class="mySubheader">Mitglieds Nummer</v-subheader>
              </v-col>
              <v-col cols="8">
                <v-text-field
                    v-model="member.Mitgliedsnummer"
                    :rules="[rules.required]"
                    :error-messages="errorMessages"
                ></v-text-field>
              </v-col>
            </v-row>
            <!--              <v-row>-->
            <!--                <v-col cols="3">-->
            <!--                  <v-subheader class="mySubheader">Passwort</v-subheader>-->
            <!--                </v-col>-->
            <!--                <v-col cols="8">-->
            <!--                  <span id="Hinweis_span">Aus einem Passwortgenerator einfügen</span>-->
            <!--                  <v-text-field-->
            <!--                      v-model="EditMember.Passwort"-->
            <!--                      :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"-->
            <!--                      :type="show_password ? 'text' : 'password'"-->
            <!--                      :rules="[rules.required]"-->
            <!--                      :error-messages="errorMessages"-->
            <!--                      @click:append="show_password = !show_password"-->
            <!--                  ></v-text-field>-->
            <!--                </v-col>-->
            <!--              </v-row>-->
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="card-actions">
        <v-spacer></v-spacer>
        <v-btn
            color="green darken-1"
            text
            @click="closeDialogMemberChange"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="green darken-1"
            text
            @click="updateUser()"
        >
          Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>
<script>
export default {
  name: "MemberUpdateDialog",
  props: {
    showDialogMemberChange: Boolean,
    member: {
      type: Object,
      default: () => ({
        vorname: '',
        name: '',
        Mitgliedsnummer: '',
        UserID: null,
      }),
    },
  },
  data: () => ({
    dialog_member_update: false,
    show_password: false,
    formHasErrors: false,
    errorMessages: '',
    rules: {
      required: value => !!value || 'Pflichtfeld.',
      counter: value => value.length <= 200 || 'Max 200 Zeichen',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Ungültige E-Mail.'
      },
    },
  }),

  methods: {
    async updateUser() {
      if (this.$refs.form_update_member.validate()) {
        const Data = {
          UserID: this.member.UserID,
          Vorname: this.member.vorname,
          Nachname: this.member.name,
          MitgliedID: this.member.Mitgliedsnummer
        };

        await this.$store.dispatch('ClubApp/updateMember', Data)
            .then(
                this.$emit('closeDialogMemberChange', false)
            )
      }
    },
    closeDialogMemberChange() {
      this.$emit('closeDialogMemberChange', false);
    },
  }
}
</script>

<style scoped>
.mySubheader {
  font-weight: bold;
}

#Hinweis_span {
  font-weight: bold;
}
</style>